import { styled, Tooltip, tooltipClasses, TooltipProps, Typography } from "@mui/material";
import { FC } from "react";

interface TooltipsCustomProps {
    tooltipText: any;
    buttonAltText: string;
    placement: any;
}

const MUITooltipCustom: FC<TooltipsCustomProps> = (props) => {

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip enterTouchDelay={150} arrow {...props} classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: '#B7CECF',
          color: '#18322E',
          maxWidth: 256,
          fontSize: '14px',
          padding: '24px',
          textAlign: 'left',
          fontWeight: 'medium',
          "fontFamily": `"Manrope", sans-serif`,
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: '#B7CECF',
          }
      }));

    return (
        <>
            <HtmlTooltip tabIndex={0} 
                title={ <>{props.tooltipText}</>}
                placement={props.placement}>
                <button type="button" className="invisibleButton no-print">
                    <img id="icon-info" loading="lazy" alt={props.buttonAltText} aria-describedby="tooltip" src="images/ic-info-Celeste.svg" className="ic-info" />
                </button>
            </HtmlTooltip>
        </>
    );
}

export default MUITooltipCustom;